import * as yup from 'yup'
import { TenantConfigFormProfile } from './tenant-config-form.profile'

const isGeoAnchorPartial = (v: TenantConfigFormProfile) => {
  const fields = [v.yardMapAnchorLatitude, v.yardMapAnchorLongitude, v.yardMapNorthRotationDegrees]
  const filled = fields.filter(f => f != null).length
  return filled === 0 || filled === 3
}

export const schema = (): yup.Schema<TenantConfigFormProfile> =>
  yup
    .object({
      id: yup.number().optional(),
      name: yup.string().label('Name').required(),
      reeferContainerMaxUnpluggedTime: yup.number().emptyAsUndefined().min(0).max(720),
      truckArrivalWindowDuration: yup.number().emptyAsUndefined().min(0).max(720),
      timezone: yup.string().label('Timezone').required(),
      allocationRuleWarningThreshold: yup.number().emptyAsUndefined().integer().min(0).max(99),
      blockWarningThreshold: yup.number().emptyAsUndefined().integer().min(0).max(99),
      yardWarningThreshold: yup.number().emptyAsUndefined().integer().min(0).max(99),
      yardMapAnchorLatitude: yup.number().nullable().min(-90).max(90).optional(),
      yardMapAnchorLongitude: yup.number().nullable().min(-180).max(180).optional(),
      yardMapNorthRotationDegrees: yup.number().nullable().min(0).lessThan(360).optional(),
    })
    .test('geo-anchor-all-or-nothing', 'Geo-anchor fields must all be set or all be empty', v =>
      isGeoAnchorPartial(v as TenantConfigFormProfile),
    )
